import { SecurityDisposeResult } from './constants/enums'

const PRD_DISPOSE_CODES = Object.values(SecurityDisposeResult).filter(
  (v): v is SecurityDisposeResult => typeof v === 'number',
)

const PRD_CODE_SET = new Set<number>(PRD_DISPOSE_CODES)

function uniqueCodes (codes: number[]): number[] {
  return [...new Set(codes.filter((c) => Number.isFinite(c) && c >= 0))]
}

function expandDisposeResultBitmask (value: number): number[] {
  const matched = PRD_DISPOSE_CODES.filter((code) => (value & code) === code)
  if (matched.length > 1) return uniqueCodes(matched)
  if (matched.length === 1 && matched[0] !== value) return matched
  return []
}

/** 解析列表/详情处置结果（PRD 1–7，支持数组、逗号分隔字符串、位图） */
export function parseHandleResultCodes (
  handleResult?: number | number[] | string,
  handleResults?: number[],
): number[] {
  if (handleResults?.length) {
    return uniqueCodes(handleResults.filter((c) => PRD_CODE_SET.has(c)))
  }

  if (Array.isArray(handleResult)) {
    return uniqueCodes(handleResult.filter((c) => PRD_CODE_SET.has(c)))
  }

  if (typeof handleResult === 'string') {
    const parts = handleResult.split(/[,|]/).map((s) => Number(s.trim()))
    return uniqueCodes(parts.filter((c) => PRD_CODE_SET.has(c)))
  }

  if (handleResult == null || handleResult === 0) return []

  const n = Number(handleResult)
  if (!Number.isFinite(n)) return []

  if (PRD_CODE_SET.has(n)) return [n]

  const fromBitmask = expandDisposeResultBitmask(n)
  if (fromBitmask.length) return fromBitmask

  return []
}

export function deriveDisposeFlags (
  handleResult?: number | number[] | string,
  handleResults?: number[],
) {
  const codes = parseHandleResultCodes(handleResult, handleResults)
  return {
    ip_blocked: codes.includes(SecurityDisposeResult.BlockIp),
    domain_blocked: codes.includes(SecurityDisposeResult.BlockDomain),
    process_killed: codes.some(
      (c) =>
        c === SecurityDisposeResult.KillProcess ||
        c === SecurityDisposeResult.DenyExecuteAndKill,
    ),
  }
}
